import React from 'react';
import { createDashboardPageClassName } from './dashboardPageStyles';

type TProps = {
  text: string;
};

export const DashboardPageTitle: React.FC<TProps> = ({ text }) => (
  <div className={createDashboardPageClassName('title')}>{text}</div>
);
